import { useMemo, createContext } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'dark'
      ? {
          // palette values for dark mode
          palette: {
            primary: '#1A202C',
            secondary: '#84D8C5',
            tertiary: '#2d3341',
          },
          background: {
            default: '#212c3f',
            paper: '#1A202C',
          },
          text: {
            primary: '#FFF',
            secondary: '#84D8C5',
          },
        }
      : {
          // palette values for light mode
          palette: {
            primary: '#FFF',
            secondary: '#84D8C5',
            tertiary: '#EBEBEB',
          },
          background: {
            default: '#EFEFEF',
            paper: '#FFF',
          },
          text: {
            primary: '#1A202C',
            secondary: '#84D8C5',
          },
        }),
  },
});

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export const ToggleColorMode = (props) => {
  const theme = useMemo(
    () => createTheme(getDesignTokens(props.mode)),
    [props.mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};
